import { Button } from "antd";
import React, { useState } from "react";
import Logo from "../../src/assetes/logo.png";

const Header = () => {
  const [toggleMenu, setToggleMenu] = useState(false);
  return (
    <div className="bg-white fixed top-0 left-0 right-0 shadow-md py-3 px-5 z-10">
      <div className="flex items-center">
        <div className="h-full w-24">
          <img src={Logo} className="w-full h-full" />
        </div>

        <div className="w-full text-center flex flex-col">
          {/* <label className="text-sm sm:text-xl">
            ।। श्री शिवराज्याभिषेक समिती व श्री शिवसह्याद्री संस्था महाराष्ट्र,
            शिवसह्याद्री ढोल-ताशा पथक, पनवेल ॥
          </label> */}
          <label className="text-sm sm:text-xl">
            ।।  श्री शिवसह्याद्री संस्था महाराष्ट्र ।।
          </label>
          <label className="text-sm sm:text-xl">
            नोंदणी क्र. १००७८/२०१२/ रायगड, महाराष्ट्र
          </label>
        </div>
      </div>
    </div>
  );
};

export default Header;
